import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UploadComponent } from './components/common/upload/upload.component';
import { AboutPageComponent } from './components/pages/about-page/about-page.component';
import { AddSuccessStoryPageComponent } from './components/pages/add-success-story-page/add-success-story-page.component';
import { ThoughtworksDemosComponent } from './components/pages/thoughtworks-demos/thoughtworks-demos.component';
import { BlogDetailsPageComponent } from './components/pages/blog-details-page/blog-details-page.component';
import { BlogPageComponent } from './components/pages/blog-page/blog-page.component';
import { CaseStudiesDetailsPageComponent } from './components/pages/case-studies-details-page/case-studies-details-page.component';
import { CaseStudiesThreeColumnsPageComponent } from './components/pages/case-studies-three-columns-page/case-studies-three-columns-page.component';
import { ContactPageComponent } from './components/pages/contact-page/contact-page.component';
import { CoursesDetailsPageComponent } from './components/pages/courses-details-page/courses-details-page.component';
import { CoursesPageComponent } from './components/pages/courses-page/courses-page.component';
import { DataIngestionRequestComponent } from './components/pages/data-ingestion-request/data-ingestion-request.component';
import { ErrorPageComponent } from './components/pages/error-page/error-page.component';
import { EventsDetailsPageComponent } from './components/pages/events-details-page/events-details-page.component';
import { EventsPageComponent } from './components/pages/events-page/events-page.component';
import { FaqPageComponent } from './components/pages/faq-page/faq-page.component';
import { GalleryPageComponent } from './components/pages/gallery-page/gallery-page.component';
import { HomepageFourComponent } from './components/pages/homepage-four/homepage-four.component';
import { HomepageThreeComponent } from './components/pages/homepage-three/homepage-three.component';
import { HomepageTwoComponent } from './components/pages/homepage-two/homepage-two.component';
import { SearchResultsPageComponent } from './components/pages/search-results-page/search-results-page.component';
import { ServicesDetailsPageComponent } from './components/pages/services-details-page/services-details-page.component';
import { ServicesPageComponent } from './components/pages/services-page/services-page.component';
import { SuccessStoriesPageComponent } from './components/pages/success-stories-page/success-stories-page.component';
import { SuccessStoryDetailsPageComponent } from './components/pages/success-story-details-page/success-story-details-page.component';
import { TeamPageComponent } from './components/pages/team-page/team-page.component';
import { InsightsDashboardPageComponent } from './components/pages/insights-dashboard/insights-dashboard-page.component';


const routes: Routes = [
    {
        path: "",
        canActivate: [MsalGuard],
        component: HomepageFourComponent,
    },
    {
        path: "home-two",
        canActivate: [MsalGuard],
        component: HomepageTwoComponent,
    },
    {
        path: "home-three",
        canActivate: [MsalGuard],
        component: HomepageThreeComponent,
    },
    {
        path: "home-four",
        canActivate: [MsalGuard],
        component: HomepageFourComponent,
    },
    {
        path: "about-us",
        canActivate: [MsalGuard],
        component: AboutPageComponent,
    },
    {
        path: "team",
        canActivate: [MsalGuard],
        component: TeamPageComponent,
    },
    {
        path: "services",
        canActivate: [MsalGuard],
        component: ServicesPageComponent,
    },
    {
        path: "services-details",
        canActivate: [MsalGuard],
        component: ServicesDetailsPageComponent,
    },
    {
        path: "platforms-kepler",
        canActivate: [MsalGuard],
        component: ServicesDetailsPageComponent,
        data: { kind: "kepler" },
    },
    {
        path: "platforms-mdp",
        canActivate: [MsalGuard],
        component: ServicesDetailsPageComponent,
        data: { kind: "mdp" },
    },
    {
        path: "platforms-uda",
        canActivate: [MsalGuard],
        component: ServicesDetailsPageComponent,
        data: { kind: "uda" },
    },
    {
        path: "platforms-osdu",
        canActivate: [MsalGuard],
        component: ServicesDetailsPageComponent,
        data: { kind: "osdu" },
    },
    {
        path: "platforms",
        canActivate: [MsalGuard],
        component: ServicesPageComponent,
    },
    {
        path: "services-details",
        canActivate: [MsalGuard],
        component: ServicesDetailsPageComponent,
    },
    {
        path: "gallery",
        canActivate: [MsalGuard],
        component: GalleryPageComponent,
    },
    {
        path: "courses",
        canActivate: [MsalGuard],
        component: CoursesPageComponent,
    },
    {
        path: "courses-details",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
    },
    {
        path: "university",
        canActivate: [MsalGuard],
        component: CoursesPageComponent,
    },
    {
        path: "university-documentation",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "documentation" },
    },
    {
        path: "university-kepler-data-eng",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "Kepler-data-eng" },
    },
    {
        path: "university-kepler",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "university-kepler" },
    },
    {
        path: "university-kepler-deeper",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "university-kepler-deeper" },
    },
    {
        path: "university-snowflake",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "university-snowflake" },
    },
    {
        path: "snowflake-datavisualization",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "snowflake-datavisualization" },
    },
    {
        path: "snowflake-datawarehousing",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "snowflake-datawarehousing" },
    },
    {
        path: "university-kepler-data-eng-201",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "Kepler-data-eng-201" },
    },
    {
        path: "university-kepler-data-ana",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "Kepler-data-ana" },
    },
    {
        path: "university-kepler-data-ana-201",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "Kepler-data-ana-201" },
    },
    {
        path: "university-airflow-training",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "airflow-training" },
    },
    {
        path: "openshift-basics",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "openshift-basics" },
    },
    {
        path: "openshift-foundation",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "openshift-foundation" },
    },
    {
        path: "university-kusto",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "university-kusto" },
    },
    {
        path: "kusto-insights",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "kusto-insights" },
    },
    {
        path: "university-azure",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "azure" },
    },
    {
        path: "azure-dataexplorer",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "azure-dataexplorer" },
    },
    {
        path: "azure-datafactory",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "azure-datafactory" },
    },
    {
        path: "azure-createdatafactory",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "azure-createdatafactory" },
    },
    {
        path: "azure-createpipeline",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "azure-createpipeline" },
    },
    {
        path: "university-mdp",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "university-mdp" },
    },
    {
        path: "university-uda",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "university-uda" },
    },
    {
        path: "azure-databricks",
        canActivate: [MsalGuard],
        component: CoursesDetailsPageComponent,
        data: { kind: "azure-databricks" },
    },
    {
        path: "events",
        canActivate: [MsalGuard],
        component: EventsPageComponent,
    },
    {
        path: "events-details",
        canActivate: [MsalGuard],
        component: EventsDetailsPageComponent,
    },
    {
        path: "case-studies-3-columns",
        canActivate: [MsalGuard],
        component: CaseStudiesThreeColumnsPageComponent,
    },
    {
        path: "platform-status",
        canActivate: [MsalGuard],
        //component: CaseStudiesDetailsPageComponent
    },
    {
        path: "community-of-practice-feedback",
        canActivate: [MsalGuard],
        component: ContactPageComponent,
    },
    {
        path: "data-foundation",
        canActivate: [MsalGuard],
        component: CaseStudiesThreeColumnsPageComponent,
        data: { kind: "data-foundation" },
    },
    {
        path: "data-foundation-governance",
        canActivate: [MsalGuard],
        component: CaseStudiesDetailsPageComponent,
        data: { kind: "data-foundation-governance" },
    },
    {
        path: "data-foundation-architecture",
        canActivate: [MsalGuard],
        component: CaseStudiesDetailsPageComponent,
        data: { kind: "data-foundation-architecture" },
    },
    {
        path: "case-studies-details",
        canActivate: [MsalGuard],
        component: CaseStudiesDetailsPageComponent,
    },
    {
        path: "error",
        canActivate: [MsalGuard],
        component: ErrorPageComponent,
    },
    {
        path: "faq",
        canActivate: [MsalGuard],
        component: FaqPageComponent,
    },
    {
        path: "data-foundation-faqs",
        canActivate: [MsalGuard],
        component: FaqPageComponent,
    },
    {
        path: "blog",
        canActivate: [MsalGuard],
        component: BlogPageComponent,
    },
    {
        path: "blog-details",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
    },
    {
        path: "what-is-CoP",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
        data: { kind: "what-is-CoP" },
    },
    {
        path: "benefits-CoP",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
        data: { kind: "benefits-CoP" },
    },
    {
        path: "CoP-Roles",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
        data: { kind: "CoP-Roles" },
    },
    {
        path: "UDF-CoP",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
        data: { kind: "UDF-CoP" },
    },
    {
        path: "CoP-Newsletter1",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
        data: { kind: "CoP-Newsletter1" },
    },
    {
        path: "CoP-Newsletter2",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
        data: { kind: "CoP-Newsletter2" },
    },
    {
        path: "CoP-Newsletter3",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
        data: { kind: "CoP-Newsletter3" },
    },
    {
        path: "community-of-practice",
        canActivate: [MsalGuard],
        component: BlogPageComponent,
        data: { kind: "CoP" },
    },
    {
        path: "CoP-Newsletters",
        canActivate: [MsalGuard],
        component: BlogPageComponent,
        data: { kind: "newsletters" },
    },
    {
        path: "community-of-practice-details",
        canActivate: [MsalGuard],
        component: BlogDetailsPageComponent,
    },
    {
        path: "contact",
        canActivate: [MsalGuard],
        component: ContactPageComponent,
    },
    {
        path: "kepler-data-ingestion-request-form",
        canActivate: [MsalGuard],
        component: DataIngestionRequestComponent,
    },
    {
        path: "add-success-story",
        canActivate: [MsalGuard],
        component: AddSuccessStoryPageComponent,
    },
    {
        path: "success-stories",
        canActivate: [MsalGuard],
        component: SuccessStoriesPageComponent,
    },
    {
        path: "success-stories-details/:story",
        canActivate: [MsalGuard],
        component: CaseStudiesDetailsPageComponent,
        data: { kind: "success-stories-details" },
    },
    {
        path: "success-stories/:story",
        canActivate: [MsalGuard],
        component: SuccessStoryDetailsPageComponent,
        data: { kind: "success-stories-details" },
    },
    {
        path: "edit-success-story/:story",
        canActivate: [MsalGuard],
        component: AddSuccessStoryPageComponent,
        data: { kind: "success-stories-details" },
    },
    {
        path: "data-products",
        canActivate: [MsalGuard],
        component: ThoughtworksDemosComponent,
        data : {kind : 'data-products'}
    },
    {
        path: "search-results",
        canActivate: [MsalGuard],
        component: SearchResultsPageComponent,
    },
    {
        path: "insights-dashboard",
        canActivate: [MsalGuard],
        component: InsightsDashboardPageComponent,
    },

    // Here add new component

    { path: "**", component: ErrorPageComponent }, // This line will remain down from the whole component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {}), UploadComponent],
    exports: [RouterModule],
})
export class AppRoutingModule {}
